import classNames from 'classnames';
import React from 'react';
import { Alert } from 'react-bootstrap';

import { HIVE_STATIC_ICON_PATH_V3 } from 'root/widgets/constants';
import { SvgIcon } from 'root/widgets/svg-icon';

import './hui-alert.scss';
import { Heading } from './sub-components';
import { HUIAlertProps } from './types';

const HUIAlert: React.FC<HUIAlertProps> = ({ className, children, icon, onClose, ...props }) => {
  const defaultIconClassName = {
    danger: 'pgicon pgicon-warning-o',
    warning: 'pgicon pgicon-warning-o',
  };

  const shouldShowIcon = icon && props.variant !== 'education';
  const isEducationAlert = props.variant === 'education';

  const handleCloseBtnClick = () => onClose?.(null, null);

  return (
    <Alert className={classNames('hui-alert-root', className)} {...props}>
      {shouldShowIcon && <i {...icon} />}
      {!icon && props.variant && !isEducationAlert && <i className={defaultIconClassName[props.variant]} />}
      <div>{children}</div>
      {isEducationAlert && (
        <div className="alert-close-btn">
          <button type="button" className="icon" aria-label="Close alert" onClick={handleCloseBtnClick}>
            <SvgIcon src={`${HIVE_STATIC_ICON_PATH_V3}/cross-small.svg`} width={24} height={24} />
          </button>
        </div>
      )}
    </Alert>
  );
};

export default Object.assign(HUIAlert, {
  Heading,
  Link: Alert.Link,
});
